import React, { createContext, useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAuthHeaders, PATH_INFO } from "../pages/util/helper";

type NameCollationsResponseType = {
  collation_value: string
  measure_name: string
}

export const NameCollationsContext = createContext<{
  nameCollations: NameCollationsResponseType[]
}>({
  nameCollations: []
})

export const UpdateNameCollationsContext = createContext<{
  refreshNameCollations: () => void
}>({
  refreshNameCollations: async () => { }
})

export function useNameCollationsContext() {
  const [nameCollations, setNameCollations] = useState([])

  const navigate = useNavigate()

  const refreshNameCollations = useCallback(async () => {
    try {
      const headers = getAuthHeaders(navigate, {
        'Content-Type': 'application/json',
      })
      if (!headers) {
        return
      }

      const res = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/apis/admin/name-collations`, {
        method: "GET",
        headers,
      })
      if (res.status === 401) {
        sessionStorage.removeItem('token')
        navigate(PATH_INFO.LOGIN.PATH)
      }

      if (!res.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await res.json();
      setNameCollations(data);
    } catch (error) {
      console.error("Error fetching name collations.");
    }
  }, [navigate])

  return {
    nameCollations,
    refreshNameCollations
  }
}

export function NameCollationsProvider({ children }: { children: React.ReactNode }) {
  const { nameCollations, refreshNameCollations } = useNameCollationsContext()

  return (
    <UpdateNameCollationsContext.Provider value={{ refreshNameCollations }}>
      <NameCollationsContext.Provider value={{ nameCollations }}>
        {children}
      </NameCollationsContext.Provider>
    </UpdateNameCollationsContext.Provider>
  )
}